<template>
  <div class="project-holder">
    <label :for="inputId">{{ label }}</label>
    <div
      :id="holderId"
      class="project-input-holder"
      @click="$emit('holder-click')"
    >
      <slot></slot>
    </div>

    <button v-if="showList" @click="$emit('show-list')" class="project-list">
      <img src="@/images/icons/list-icon.svg" class="list-icon" />
    </button>
  </div>
</template>

<script>
/**
 * Wrapper rond een label + ProjectInput-rij zoals gebruikt in Invoice.vue.
 *
 * Vat de herhaalde structuur (label, klikbare input-wrapper, optionele
 * lijst-knop) samen zonder de generieke ProjectInput te vervuilen. De
 * ProjectInput zelf wordt via de default-slot doorgegeven, zodat alle
 * props/events transparant blijven.
 *
 * Properties:
 * - label    : weergegeven labeltekst
 * - inputId  : `for`-attribuut op het label (en holder-id indien geen aparte holderId)
 * - holderId : optioneel id op de klikbare wrapper (bv. 'searchproj')
 * - showList : toont de lijst-knop rechts
 *
 * Events:
 * - holder-click : klik op de input-wrapper (bv. om de keuzelijst te openen)
 * - show-list    : klik op de lijst-knop
 */

export default {
  props: {
    label: { type: String, default: '' },
    inputId: { type: String, default: '' },
    holderId: { type: String, default: '' },
    showList: { type: Boolean, default: false }
  },
  emits: ['holder-click', 'show-list']
}
</script>

<style lang="scss" scoped>
.project-holder {
  position: relative;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding-top: 3px;

  > div {
    flex: 1 1 105px;
  }

  label {
    float: none;
    margin-right: 10px;
    white-space: nowrap;
    flex: 0 0;
    line-height: 34px;
  }
}

.project-list {
  padding-bottom: 7px;
  padding-left: 5px;

  .list-icon :deep(g) {
    fill: var(--sub-color);
  }
}
</style>
